import { announcementKeys } from '@/features/profile/announcementKeys';
import { useBannerStore, type CommunityBanner } from '@/state/bannerStore';
import { registerBinding } from './bindings';

/** FR-029/FR-030: the server tells a member's open app to show a banner (contracts/realtime-events.md). */
const isString = (value: unknown): value is string => typeof value === 'string';
const TARGET_TYPES = new Set(['post', 'event', 'promotion', 'announcement']);

registerBinding('messaging', 'banner:new-message', (payload) => {
  const p = payload as Record<string, unknown> | null;
  if (
    !p ||
    !isString(p.conversationId) ||
    !isString(p.senderId) ||
    !isString(p.senderName) ||
    !isString(p.preview)
  ) {
    return;
  }
  useBannerStore.getState().showMessage({
    conversationId: p.conversationId,
    senderId: p.senderId,
    senderName: p.senderName,
    preview: p.preview,
  });
});

registerBinding('messaging', 'banner:community-update', (payload, { queryClient }) => {
  const p = payload as Record<string, unknown> | null;
  if (!p || !isString(p.text)) {
    return;
  }
  const banner: CommunityBanner = { text: p.text };
  if (isString(p.title)) banner.title = p.title;
  if (isString(p.targetType) && TARGET_TYPES.has(p.targetType)) {
    banner.targetType = p.targetType as CommunityBanner['targetType'];
    if (isString(p.targetId)) banner.targetId = p.targetId;
  }
  useBannerStore.getState().showCommunity(banner);
  // An announcement is kept: the page and the count of new ones reload straight away.
  if (banner.targetType === 'announcement') {
    void queryClient.invalidateQueries({ queryKey: announcementKeys.all });
  }
});
